import { ArrowsPointingOutIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import CodeEditorModal from '../../modals/CodeEditorModal';
import IconButton from '../Common/IconButton';
import { CodeEditorTextArea } from '../FormFields/CodeEditor/CodeEditorTextArea';

interface Props {
  title?: string;
  editable?: boolean;
  value?: string;
  setValue?: any;
  update?: any;
}

export default function SettingSectionCodeArea({
  title,
  editable,
  value,
  setValue,
  update,
}: Props) {
  const [editing, setEditing] = useState(false);
  const [initialValue, setInitialValue] = useState('');
  const [codeModalOpen, setCodeModalOpen] = useState(false);
  const [callUpdate, setCallUpdate] = useState(false);

  useEffect(() => {
    if (editing) {
      setInitialValue(value as string);
    }
  }, [editing]);

  useEffect(() => {
    if (callUpdate) {
      update();
      setCallUpdate(false);
    }
  }, [callUpdate, update]);

  return (
    <div className="flex flex-col gap-0 pt-6">
      <CodeEditorModal
        code={value ?? ''}
        onSave={(code) => {
          setValue(code);
          setEditing(false);
          setCallUpdate(true);
        }}
        open={codeModalOpen}
        onClose={() => {
          setCodeModalOpen(false);
        }}
      />
      <div className="relative">
        <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
          {title}
        </dt>
        {editing && (
          <IconButton
            variant="ternary"
            className="absolute -top-0.5 end-0"
            onClick={() => setCodeModalOpen(true)}
          >
            <ArrowsPointingOutIcon className="h-4 w-4 text-gray-500" />
          </IconButton>
        )}
      </div>
      <dd className="mt-1 flex flex-col justify-between gap-2 gap-x-6 sm:mt-0 sm:flex-auto">
        <CodeEditorTextArea
          value={value ?? ''}
          onChange={(code) => setValue(code)}
          disabled={!editing}
          className="h-56"
        />

        <div className="flex gap-4">
          {editing ? (
            <button
              type="button"
              className="font-semibold text-gray-600 hover:text-gray-500"
              onClick={() => {
                setValue(initialValue as string);
                setEditing((a) => !a);
              }}
            >
              Cancel
            </button>
          ) : (
            <></>
          )}
          {editable ? (
            <button
              type="button"
              className="font-semibold text-indigo-600 hover:text-indigo-500"
              onClick={() => {
                setEditing((a) => !a);
                if (editing) {
                  update();
                }
              }}
            >
              {editing ? 'Save' : 'Edit'}
            </button>
          ) : (
            <></>
          )}
        </div>
      </dd>
    </div>
  );
}
